import androidx.compose.runtime.Composable
import com.radioshqiplive.player.MediaPlayerController

@Composable
fun MainView() = GlobalWindowView(webMode = true, mediaPlayerController = MediaPlayerController())


